import * as React from "react";
const SvgFiRrPig = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-pig_svg__a)">
      <path
        fill="#062147"
        d="M23 10h-.257C22.015 7.263 19.786 5.09 17 4.31V1.94c0-.613-.587-1.071-1.176-.904-1.327.378-2.36 1.568-2.702 2.965H8.266A8.4 8.4 0 0 0 2.41 6.353a4.4 4.4 0 0 1-.416-1.47 1 1 0 1 0-1.986.231C.138 6.25.501 7.223 1.09 8.02a7.7 7.7 0 0 0-1.072 3.45A7.97 7.97 0 0 0 4 18.92V19c0 1.654 1.346 3 3 3a3.01 3.01 0 0 0 2.83-2h2.342a3.01 3.01 0 0 0 2.83 2 3.005 3.005 0 0 0 2.97-2.573A8.02 8.02 0 0 0 22.408 15h.592a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1m-6.285 7.748a1 1 0 0 0-.715.958v.293a1.001 1.001 0 0 1-2 0 1 1 0 0 0-1-1H9a1 1 0 0 0-1 1 1.001 1.001 0 0 1-2 0v-.683a1 1 0 0 0-.57-.903 5.98 5.98 0 0 1-3.417-5.815c.065-1.004.5-2.343 1.36-3.352 1.152-1.372 2.923-2.247 4.893-2.247h6.47c3.205 0 5.944 2.373 6.235 5.403.275 2.86-1.516 5.528-4.257 6.345zM18 10.5A1.5 1.5 0 1 1 15 10.499a1.5 1.5 0 0 1 3.001 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-pig_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPig;
